<template>
  <LegalPage page="privacy">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Last Updated: September 14, 2026</p>

    <p>
      Welcome to InstaSave (accessible from
      <a href="https://instasaves.io/">https://instasaves.io/</a>). Your privacy is of
      paramount importance to us. This Privacy Policy document outlines the types of
      information that is collected and recorded by InstaSave and how we use it.
    </p>

    <section>
      <h2>1. No Personal Data Collection &amp; Media Hosting</h2>
      <p>
        InstaSave operates as an online web tool for downloading publicly available media
        from Instagram. We prioritize user privacy and adhere to the following strict
        principles:
      </p>
      <ul>
        <li>
          <strong>No User Account Required:</strong> You can access and use our service
          without registration, login, or providing any personally identifiable information
          (PII).
        </li>
        <li>
          <strong>No Media Storage:</strong> We do not host, store, or archive any videos,
          photos, or audio content on our servers. All media items are downloaded directly
          from Instagram's Content Delivery Network (CDN) servers.
        </li>
        <li>
          <strong>No Data Tracking:</strong> We do not keep records of the links you paste
          or the media files you download.
        </li>
      </ul>
    </section>

    <section>
      <h2>2. Non-Personal Information &amp; Log Files</h2>
      <p>
        Like most standard web servers, InstaSave uses log files. The information inside the
        log files includes internet protocol (IP) addresses, browser type, Internet Service
        Provider (ISP), date/time stamp, referring/exit pages, and possibly the number of
        clicks. This information is purely used to analyze trends, administer the site, track
        users' movement around the site, and gather broad demographic information for site
        performance optimization. None of this information is linked to any personally
        identifiable data.
      </p>
    </section>

    <section>
      <h2>3. Cookies and Web Beacons</h2>
      <p>
        InstaSave uses "Cookies" to store information about visitors' preferences and the
        pages on the website that the visitor accessed or visited. The information is used
        to optimize the users' experience by customizing our web page content based on
        visitors' browser type and/or other information.
      </p>
    </section>

    <section>
      <h2>4. Third-Party Advertising and Analytics</h2>
      <p>
        We may use third-party advertising services (such as Google Ads) and web analytics
        tools (such as Google Analytics) on our site. These third-party vendors may use
        cookies, web beacons, and similar technologies to collect information about your
        interactions with our website to measure ad effectiveness and personalize
        advertising content. You can choose to disable cookies through your individual
        browser options.
      </p>
    </section>

    <section>
      <h2>5. Intellectual Property &amp; Trademark Disclaimer</h2>
      <p>
        InstaSave is an independent website and is not affiliated, associated, authorized,
        endorsed by, or in any way officially connected with Instagram, Meta Platforms,
        Inc., or any of their subsidiaries or affiliates. All product names, logos, brands,
        trademarks, and registered trademarks displayed on this site are the property of
        their respective owners.
      </p>
    </section>

    <section>
      <h2>6. Contact Us</h2>
      <p>
        If you have additional questions or require more information about our Privacy
        Policy, do not hesitate to contact us via email at:
        <a href="mailto:support@instasaves.io">support@instasaves.io</a>.
      </p>
    </section>
  </LegalPage>
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Privacy',
  components: {
    LegalPage
  }
};
</script>
